import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Search from "./pages/Search";
import ExtraProfile from "./pages/ExtraProfile";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import Invite from "./pages/Invite";
import Privacy from "./pages/Privacy";
import DataProtection from "./pages/DataProtection";
import Terms from "./pages/Terms";
import NewsArticle from "./pages/NewsArticle";
import CastingRequest from "./pages/CastingRequest";
import CountryPage from "./pages/CountryPage";
import CastingCallsPage from "./pages/CastingCallsPage";
import CastingCallDetail from "./pages/CastingCallDetail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/search" element={<Search />} />
              <Route path="/uk" element={<CountryPage slug="uk" />} />
              <Route path="/usa" element={<CountryPage slug="usa" />} />
              <Route path="/ireland" element={<CountryPage slug="ireland" />} />
              <Route path="/extras/:slug" element={<ExtraProfile />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/invite/:code" element={<Invite />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/data-protection" element={<DataProtection />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/news/extras-tv-is-back" element={<NewsArticle />} />
              <Route path="/casting-calls" element={<CastingCallsPage />} />
              <Route path="/casting-calls/:id" element={<CastingCallDetail />} />
              <Route path="/casting-request" element={<CastingRequest />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
              <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/:slug" element={<ExtraProfile />} />
            </Routes>
          </main>
          <Footer />
          <Toaster theme="dark" position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
